import React, { useRef } from 'react';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import CountryData from '../../hooks/config/useConfig';
import useUser from '../../hooks/user/useUser';
import { TermsConditionsCL } from './TermsConditionsCL';
import { TermsConditionsUY } from './TermsConditionsUY';
import { TermsConditionsPA } from './TermsConditionsPA';
import { TermsConditionsCO } from './TermsConditionsCO';

export const ContractPage = () => {
  const navigate = useNavigate();
  const { country } = CountryData();
  const { userState } = useUser();
  const termsRef = useRef<HTMLDivElement | null>(null);

  const handleDownloadPDF = async () => {
    const contentElement = termsRef.current;
    if (!contentElement) return;

    // Lightweight text-based PDF using jsPDF only
    const { jsPDF } = await import('jspdf');
    const pdf = new jsPDF('p', 'mm', 'a4');

    const marginLeft = 12;
    const marginTop = 15;
    const marginRight = 12;
    const lineHeight = 6; // approx for 11pt font

    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(11);

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const maxLineWidth = pageWidth - marginLeft - marginRight;

    const title = `Términos y Condiciones - ${country || ''}`.trim();
    pdf.setFontSize(14);
    pdf.text(title, marginLeft, marginTop);
    pdf.setFontSize(11);

    const text = contentElement.innerText || '';
    const wrappedLines = pdf.splitTextToSize(text, maxLineWidth);

    let cursorY = marginTop + 8;
    wrappedLines.forEach((line: string) => {
      if (cursorY > pageHeight - marginTop) {
        pdf.addPage();
        cursorY = marginTop;
      }
      pdf.text(line, marginLeft, cursorY);
      cursorY += lineHeight;
    });

    const filename = `Contrato_IRIS_${country || 'XX'}.pdf`;
    pdf.save(filename);
  };

  return (
    <Container className="py-4">
      <h1 className="text-center mb-4">Términos y Condiciones</h1>
      <div ref={termsRef} className="terms-conditions-content">
        {country === 'CL' && <TermsConditionsCL />}
        {country === 'UY' && <TermsConditionsUY />}
        {country === 'PA' && <TermsConditionsPA />}
        {country === 'CO' && <TermsConditionsCO />}
        <div className="mt-4 p-3 border rounded bg-white">
          <p className="mb-0"><strong>Firma: {userState?.name || ''}</strong></p>
        </div>
      </div>
      <div className="text-center mt-4 d-flex justify-content-center gap-2">
        <Button variant="secondary" onClick={handleDownloadPDF}>
          Descargar PDF
        </Button>
        <Button variant="outline-secondary" onClick={() => navigate('/feed')}>
          Volver al Inicio
        </Button>
      </div>
    </Container>
  );
};